import React, { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { fetchUserById } from '../../api/User';

import * as FaIcons from 'react-icons/fa';
const FaUser = FaIcons.FaUser as unknown as React.FC;
const FaPhone = FaIcons.FaPhone as unknown as React.FC;
const FaEnvelope = FaIcons.FaEnvelope as unknown as React.FC;

interface DecodedToken {
  id: string | number;
  name?: string;
  email?: string;
  phoneNumber?: string;
  phone?: string;
}

const QuoteCreatedBySection: React.FC = () => {
  const [user, setUser] = useState<{ name: string; phone: string; email: string } | null>(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;

        const decoded = jwtDecode<DecodedToken>(token);
        
        // Try to get user info directly from JWT token first (faster, no API call)
        if (decoded.name && decoded.email) {
          setUser({
            name: decoded.name,
            phone: decoded.phoneNumber || decoded.phone || '',
            email: decoded.email,
          });
          return;
        }

        // Fallback: fetch from API if JWT doesn't have full user info
        const userId = decoded.id;
        if (!userId) return;

        const userData = await fetchUserById(String(userId));
        setUser({
          name: userData.name,
          phone: userData.phoneNumber,
          email: userData.email,
        });
      } catch (err) {
        console.error('Failed to fetch user data:', err);
      }
    };

    fetchUser();
  }, []);

  if (!user) return null;

  return (
    <div className="quote-created-box">
      <div className="quote-meta">
        <div className="quote-avatar">
          <FaUser />
        </div>
        <span>Quote created by <strong>{user.name}</strong></span>
      </div>
      <div className="quote-contact">
        <FaPhone /> <span>{user.phone}</span>
        <FaEnvelope /> <span>{user.email}</span>
      </div>
    </div>
  );
};

export default QuoteCreatedBySection;
